/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { createSlice } from "@reduxjs/toolkit";
import HomeRoomInitState from "../../../rooms/HomeRoom/state";
import { HOME_ROOM } from "../../../rooms/RoomNameConstants";

const initialState = { ...HomeRoomInitState };

const homeSlice = createSlice({
    name: HOME_ROOM,
    initialState: initialState,
    reducers: {
        setKPI: (state, action) => {
            const { field, data } = action.payload
            state.kpi.info[field] = data;
            state.kpi.list[field] = state.kpi.info[field].length;
        },
        setCurrentPlanDates: (state, action) => {
            state.currentPlanDates = action.payload;
        },
        setCriticalJobsData: (state, action) => {
            const { field, data } = action.payload
            state.criticalJobsData[field] = data;
        },
        setOpenedKPI: (state, action) => {
            state.kpi.opened = action.payload.opened
        },
        setKPISettings: (state, action) => {
            state.kpi.settings = action.payload
        },
        setDataRightChart: (state, action) => {
            const { values, labels } = action.payload
            state.dataRightChart.values = values
            state.dataRightChart.labels = labels
        },
        setDataRightChartSelected: (state, action) => {
            state.dataRightChart.selected = action.payload
        },
        resetInitialHomeRoom: (state) => {
            Object.assign(state, initialState)
        },
        loadRemoteHomeRoom: (state, action) => {
            Object.assign(state, action.payload)
        }
    }
});

export const {
    setKPI,
    setKPISettings,
    setOpenedKPI,
    setCurrentPlanDates,
    setDataRightChartSelected,
    loadRemoteHomeRoom,
    setCriticalJobsData,
    resetInitialHomeRoom,
    setDataRightChart,
} = homeSlice.actions;

export default homeSlice;
